import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {fetchSubject, selectSubject, wrapper} from '../state/store';
import SingleMatchTable from '../components/Tables/SingleMatchTable';
import SingleMatchTop from '../components/SingleMatch/SingleMatchTop';
import { Paper, Box, Tabs, Tab } from '@mui/material';
import { MyContainer, TeamLogos } from '../globals/Globals';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BackArrow from '../components/Navigation/BackArrow';
import { GetSingleMatch, SelectMatch } from '../state/reducers/SingleMatchReducer';
import SingleMatchLogos from '../components/SingleMatch/SingleMatchLogos';
import Loading from '../components/Loading';
//import { RegisterPageView } from '../../functions/Analytics';
import AdsenseAdd from '../components/AdsenseAdd';
import { PageContainer } from '../globals/styles';
import { useParams } from 'react-router-dom';
import { RegisterPageView } from '../globals/Analytics';

export interface Props {
    type: "matchid" | "seasonround";
}

const SingleMatch = ({type}:Props) => {
    const dispatch = useAppDispatch();
    let { matchId, season, round, team } = useParams<{matchId?:string, season?:string, round?:string, team?:string}>();

    
    
    useEffect(() => {
        if (matchId) {
            dispatch(GetSingleMatch(matchId));
            RegisterPageView({path:`/match/${matchId}`});
        }
    }, [matchId]);
    
    useEffect(() => {
        GetSingleMatchRound();
    }, [season,round,team]);

    let thematch = useAppSelector(SelectMatch);
    console.log("THE MATCH: ", thematch);
    let thematchgames = thematch.match['games'];


    const [ selectedTab, setSelectedTab ] = useState(0);

    function GetSingleMatchRound() {
        
        let stringSeason:string = season ? season : '';
        if (stringSeason === '2021-2022') {
            stringSeason = '2021-22';
        }
        let stringRound:string = round ? round : '';
        let stringTeam:string = team ? team : '';
        console.log(`${stringSeason}, ${stringRound}, ${stringTeam}`);
        if (season && round && team) {
            dispatch(GetSingleMatch(`${stringSeason}/${stringRound}/${stringTeam}`));
        }
        
    }
    
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
    };
    
    
    return(<div>
         <SingleMatchLogos match={thematch.match} />
        <MyContainer maxWidth="xl">
        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: "1rem" , display: "flex", justifyContent: "center"}}>
            <Tabs value={selectedTab} onChange={handleChange} variant="scrollable" style={{marginBottom: "1rem"}}>
                <Tab label="Top Players" />
                <Tab label="Player Stats" />
            </Tabs>
        </Box>
        {selectedTab === 0 ? 
            <SingleMatchTop singlematch={thematch} />
        : null }
        {selectedTab === 1 ? 
            <SingleMatchTable games={thematchgames} />
        : null }
        <AdsenseAdd />
        </MyContainer>
    </div>)
    
}

export default SingleMatch;